const caseTypeMetadata = {
  cases: {
    hex: '#CC1034',
    border: '#CC1034',
    fill: '#cc103279',
    multiplier: 8000,
  },
  recovered: {
    hex: '#7dd71d',
    border: '#7dd71d',
    fill: '#7dd71d7a',
    multiplier: 12000,
  },
  deaths: {
    hex: '#303030',
    border: '#303030',
    fill: '#30303077',
    multiplier: 20000,
  },
};

export default caseTypeMetadata;
